export default {
    data() {
        return {
            hasChanged: false,
            hasLoaded: false,
        };
    },
    watch: {
        model: {
            handler() {
                if (this.hasLoaded) {
                    this.hasChanged = true;
                }
                else {
                    this.hasLoaded = true;
                }
            },
            deep: true,
        },
    },

};
